import { render, staticRenderFns } from "./ColorPickerAndField.vue?vue&type=template&id=0fb19672&scoped=true&"
import script from "./ColorPickerAndField.vue?vue&type=script&lang=js&"
export * from "./ColorPickerAndField.vue?vue&type=script&lang=js&"
import style0 from "./ColorPickerAndField.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./ColorPickerAndField.vue?vue&type=style&index=1&id=0fb19672&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb19672",
  null
  
)

export default component.exports